import React from "react";
import useMediaQueries from "hooks/useMediaQueries.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { supportedPreviewFormats } from "../Helpers/helpers.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { getRelativePath } from "../Helpers/uploaderAPI.js";

const FilePreview = ({ file, name, fileSize, noFooter }) => {
  return (
    <div className="upload-home-file-preview">
      <Icon name={"file"} gray />
      <div className="ext-data">{file.extension || file.name}</div>
      {!noFooter ? (
        <div className="info-section">
          <Tooltip tooltipText={name}>
            <div className="name">{name}</div>
          </Tooltip>
          <div className="size">{fileSize.size + fileSize.type}</div>
        </div>
      ) : null}
    </div>
  );
};

const UploadGalleryIcon = ({ file, thumbPreview, noFooter }) => {
  const { getIsUppy } = useUploader();
  const { mobileCondition } = useMediaQueries();
  const fileObj = getIsUppy() ? file : file.file;

  const fileSize = bytesToDisplayHelper(file.size);

  const name = getRelativePath(fileObj)
    ? getRelativePath(fileObj) + "/" + file.name
    : file.name;

  const isWithPreview = mobileCondition
    ? supportedPreviewFormats.includes(fileObj.type) &&
      !fileObj.type.includes("video")
    : supportedPreviewFormats.includes(fileObj.type);

  return isWithPreview ? (
    thumbPreview ? (
      fileObj.type.includes("image") ? (
        <Image src={thumbPreview} alt={file.name} />
      ) : (
        <div className="upload-home-file-preview with-thumbnail">
          <div className="upload-video-preview">
            <Icon name={"play"} white />
          </div>
          <Image src={thumbPreview} alt={file.name} />
        </div>
      )
    ) : (
      <LoadingImageElement
        className="loader-animation-gif"
        name="preloader"
        ext="gif"
        alt=""
        title=""
      />
    )
  ) : (
    <FilePreview
      file={fileObj}
      fileSize={fileSize}
      name={name}
      noFooter={noFooter}
    />
  );
};

export default UploadGalleryIcon;
